(() => {
  if (window.__PW_CART_RULES_INIT__) return;
  window.__PW_CART_RULES_INIT__ = true;

  const nativeFetch = window.fetch.bind(window);
  const endpoint = document.body?.dataset?.pwCartRulesUrl || '';
  const eventsEndpoint = endpoint
    ? endpoint.replace(/\/api\/cart-rules(?:\?.*)?$/, '/api/storefront-events')
    : 'https://packaging-wise-upsell-crosssell.vercel.app/api/storefront-events';
  const shop = document.body?.dataset?.pwShop || window.Shopify?.shop || '';
  const analyticsSessionId = (() => {
    const key = 'pw-cart-rules-session:v1';
    try {
      let value = window.sessionStorage.getItem(key);
      if (!value) {
        value = window.crypto?.randomUUID?.() || ('pw-' + Date.now() + '-' + Math.random().toString(36).slice(2));
        window.sessionStorage.setItem(key,value);
      }
      return value;
    } catch (_) {
      return 'pw-' + Date.now() + '-' + Math.random().toString(36).slice(2);
    }
  })();
  let refreshTimer = 0;
  let modalPromise = null;
  let lastCart = null;
  let compatibilityCache = [];
  let compatibilityCacheKey = '';
  let recommendationRefreshInFlight = false;
  let recommendationRefreshQueuedCart = null;
  // Dedupe overlapping cart-open/render/preload requests so Vercel sees a
  // single resolver call for the same snapshot, not several at once.
  const ruleRequestsInFlight = new Map();
  const recommendationResults = new Map();
  let cartReadInFlight = null;
  let cartReadEpoch = -1;
  let cartEpoch = 0;

  const rootUrl = () => window.Shopify?.routes?.root || '/';
  const money = (value) => {
    try { return new Intl.NumberFormat('en-GB',{style:'currency',currency:'GBP'}).format(Number(value)||0); }
    catch (_) { return '£' + (Number(value)||0).toFixed(2); }
  };
  const esc = (value) => String(value || '').replace(/[&<>"']/g,(ch)=>({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[ch]));
  const cartRecommendationWetWipesVariants = new Set(["57265074766202","57265075356026","57265080533370","57265080992122"]);
  function recommendationPriceMarkup(product) {
    if (product?.loading) return 'Checking price and stock…';
    if (product?.price == null) return 'Price at checkout';
    const amount = Number(product.price);
    if (cartRecommendationWetWipesVariants.has(String(product.variantNumericId || '')) && Math.abs(amount - 28) < 0.005) {
      return '<s class="pw-cart-rule-card__original-price">' + esc(money(28)) + '</s> <span class="pw-cart-rule-card__offer-price">' + esc(money(25)) + '</span>';
    }
    return esc(money(product.price));
  }

  const cartProductIds = (cart) => [...new Set((cart?.items || []).map((item)=>String(item.product_id || '')).filter(Boolean))];
  const recommendationDismissStorageKey = 'pw-cart-recommendation-dismissed:v2:' + shop;
  const recommendationImpressionStorageKey = 'pw-cart-recommendation-impressions:v1:' + shop;

  function readSessionSet(key) {
    try {
      const parsed = JSON.parse(window.sessionStorage.getItem(key) || '[]');
      return new Set(Array.isArray(parsed) ? parsed : []);
    } catch (_) { return new Set(); }
  }

  const dismissedRecommendationKeys = readSessionSet(recommendationDismissStorageKey);
  const trackedRecommendationImpressions = readSessionSet(recommendationImpressionStorageKey);

  const recommendationDismissKey = (sourceId, variantId, placement) => {
    const source = String(sourceId || '').match(/(\d+)$/)?.[1] || '';
    const variant = String(variantId || '').match(/(\d+)$/)?.[1] || '';
    const surface = String(placement || '');
    return source && variant && surface ? surface + ':' + source + ':' + variant : '';
  };

  function persistSessionSet(key, values) {
    try { window.sessionStorage.setItem(key, JSON.stringify([...values])); } catch (_) {}
  }

  function persistDismissedRecommendations() {
    persistSessionSet(recommendationDismissStorageKey, dismissedRecommendationKeys);
  }

  function recommendationPlacement(module) {
    const explicit = String(module?.dataset?.placement || '');
    if (explicit) return explicit;
    if (module?.closest?.('#CartPageForm')) return 'cart_page';
    return 'cart_drawer';
  }

  function interactionPlacement() {
    if (document.querySelector('header-drawer.site-header__cart.is-active')) return 'cart_drawer';
    if (location.pathname.replace(/\/+$/,'') === rootUrl().replace(/\/+$/,'') + 'cart') return 'cart_page';
    if (/\/cart\/?$/.test(location.pathname)) return 'cart_page';
    return 'product_page';
  }

  function isRecommendationDismissed(sourceId, variantId, placement) {
    const key = recommendationDismissKey(sourceId, variantId, placement);
    return Boolean(key && dismissedRecommendationKeys.has(key));
  }

  function filterDismissedRecommendations(items, placement) {
    return (items || []).filter((entry) => {
      const sourceId = entry?.sourceProductId || '';
      const variantId = entry?.product?.variantNumericId || '';
      return !isRecommendationDismissed(sourceId, variantId, placement);
    });
  }

  function trackCartExperience(eventType, data = {}) {
    if (!eventsEndpoint || !shop) return;
    const payload = {
      eventType,
      shop,
      sessionId: analyticsSessionId,
      cartToken: lastCart?.token || '',
      currency: window.Shopify?.currency?.active || 'GBP',
      language: document.documentElement.lang || navigator.language || '',
      locale: navigator.language || '',
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || '',
      path: location.pathname + location.search,
      source: 'cart_rules',
      ...data
    };
    nativeFetch(eventsEndpoint,{
      method:'POST',
      mode:'cors',
      keepalive:true,
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify(payload)
    }).catch(()=>{});
  }

  function recommendationEventData(card, placement, action) {
    return {
      placement,
      action,
      ruleId: card?.dataset?.ruleId || '',
      productId: card?.dataset?.sourceProductId || '',
      sourceProductTitle: card?.dataset?.sourceProductTitle || '',
      targetProductId: card?.dataset?.targetProductId || '',
      targetProductTitle: card?.dataset?.targetProductTitle || '',
      variantId: card?.dataset?.variantId || '',
      itemCount: 1
    };
  }

  function trackRecommendationImpression(card, placement) {
    const key = recommendationDismissKey(card?.dataset?.sourceProductId, card?.dataset?.variantId, placement);
    if (!key || trackedRecommendationImpressions.has(key)) return;
    trackedRecommendationImpressions.add(key);
    persistSessionSet(recommendationImpressionStorageKey, trackedRecommendationImpressions);
    trackCartExperience('cart_recommendation_impression', recommendationEventData(card,placement,'impression'));
  }

  function trackVisibleRecommendationModules(root = document) {
    root.querySelectorAll?.('[data-pw-cart-rules]').forEach((module) => {
      const placement = recommendationPlacement(module);
      module.querySelectorAll('[data-pw-rule-card]').forEach((card) => {
        if (!card.hidden && !module.hidden && !isRecommendationDismissed(card.dataset.sourceProductId,card.dataset.variantId,placement)) {
          trackRecommendationImpression(card,placement);
        }
      });
    });
  }

  function pruneDismissedRecommendationModules(root = document) {
    root.querySelectorAll?.('[data-pw-cart-rules]').forEach((module) => {
      const placement = recommendationPlacement(module);
      const cards = [...module.querySelectorAll('[data-pw-rule-card]')];
      if (!cards.length) return;
      cards.forEach((card) => {
        if (isRecommendationDismissed(card.dataset.sourceProductId,card.dataset.variantId,placement)) card.remove();
      });
      if (!module.querySelector('[data-pw-rule-card]')) module.remove();
    });
  }

  function compatibilityEventData(conflicts, placement, action) {
    const first = (conflicts || [])[0] || {};
    return {
      placement,
      action,
      ruleId: first?.ruleId || '',
      productId: first?.cartProductId || '',
      sourceProductTitle: first?.cartProductTitle || '',
      targetProductId: first?.candidateProductId || '',
      targetProductTitle: first?.candidateProductTitle || '',
      variantId: first?.candidateVariantId || '',
      alertMessage: first?.message || '',
      itemCount: Math.max(1,(conflicts || []).length)
    };
  }

  const compatibilityApprovalKey = 'pw-compat-approved:v1:' + shop;
  const compatibilityApprovals = readSessionSet(compatibilityApprovalKey);
  function pairKey(conflict, cart) {
    const cartProduct = String(conflict?.cartProductId || '').match(/(\d+)$/)?.[1] || '';
    const candidateProduct = String(conflict?.candidateProductId || '').match(/(\d+)$/)?.[1] || '';
    const candidateVariant = String(conflict?.candidateVariantId || '').match(/(\d+)$/)?.[1] || '';
    const item = cart?.items?.find(row => String(row.product_id) === cartProduct);
    const cartVariant = String(item?.variant_id || '').match(/(\d+)$/)?.[1] || '';
    if (!cartProduct || !candidateProduct || !cartVariant || !candidateVariant) return '';
    return [cartProduct+':'+cartVariant,candidateProduct+':'+candidateVariant].sort().join('|');
  }
  function needsCompatibilityConsent(conflicts, cart) {
    return conflicts.filter(conflict => {
      const key = pairKey(conflict, cart);
      return !key || !compatibilityApprovals.has(key);
    });
  }
  function rememberCompatibilityConsent(conflicts, cart) {
    conflicts.forEach(conflict => {
      const key = pairKey(conflict, cart);
      if (key) compatibilityApprovals.add(key);
    });
    persistSessionSet(compatibilityApprovalKey, compatibilityApprovals);
  }
  function diameterMm(label) {
    const match = String(label || '').match(/(?:^|[^\d])(\d{2,3}(?:\.\d+)?)\s*mm\b/i);
    return match ? Number(match[1]) : null;
  }
  function packagingKind(label) {
    const title = String(label || '').toLowerCase();
    if (/\b(lid|lids)\b/.test(title)) return 'lid';
    if (/\b(bowl|bowls)\b/.test(title)) return 'bowl';
    return '';
  }
  // Safety net only for explicit bowl/lid diameters, independent of rules API availability.
  async function diameterConflicts(cart, variantIds) {
    const snapshots = await Promise.all(variantIds.map(id => variantSnapshot(id)));
    const results = [];
    snapshots.forEach((snapshot, index) => {
      const variant = snapshot?.variant;
      const title = String(variant?.name || variant?.product_title || variant?.title || '');
      const kind = packagingKind(title);
      const mm = diameterMm(title);
      if (!kind || !mm) return;
      (cart.items || []).forEach(item => {
        const cartTitle = String(item.product_title || item.title || '');
        const cartKind = packagingKind(cartTitle);
        const cartMm = diameterMm(cartTitle+' '+(item.variant_title || ''));
        if (!cartKind || !cartMm || cartKind === kind || mm === cartMm) return;
        results.push({
          ruleId:'diameter-fallback', candidateVariantId:String(variantIds[index]),
          candidateProductId:String(variant?.product_id || ''), candidateProductTitle:title,
          cartProductId:String(item.product_id || ''), cartProductTitle:cartTitle,
          cartProductHandle:String(item.handle || ''),
          message:mm+'mm and '+cartMm+'mm diameters are not compatible.'
        });
      });
    });
    return results;
  }

  function mergeTestFallbacks(_cart, _candidateVariantIds, resolved) {
    return {
      recommendations: Array.isArray(resolved?.recommendations) ? resolved.recommendations : [],
      conflicts: Array.isArray(resolved?.conflicts) ? resolved.conflicts : []
    };
  }

    const RECOMMENDATION_CACHE_TTL = 4 * 60 * 1000;
  const INSTANT_RULE_CACHE_TTL = 30 * 1000;

  function recommendationCacheKey(cart) {
    const ids = cartProductIds(cart).slice().sort().join('|');
    return ids ? 'pw-cart-recommendations:v2:' + shop + ':' + ids : '';
  }

  function readRecommendationCache(cart) {
    const key = recommendationCacheKey(cart);
    if (!key) return [];
    try {
      const raw = window.sessionStorage.getItem(key);
      if (!raw) return [];
      const parsed = JSON.parse(raw);
      if (!parsed?.ts || Date.now() - Number(parsed.ts) > RECOMMENDATION_CACHE_TTL) {
        window.sessionStorage.removeItem(key);
        return [];
      }
      return Array.isArray(parsed.items) ? parsed.items : [];
    } catch (_) { return []; }
  }

  function readInstantRecommendationCache(cart) {
    const key = recommendationCacheKey(cart);
    if (!key) return [];
    try {
      const entry = JSON.parse(window.sessionStorage.getItem(key) || 'null');
      if (!entry || Date.now() - Number(entry.ts || 0) > INSTANT_RULE_CACHE_TTL) return [];
    } catch (_) { return []; }
    return readRecommendationCache(cart);
  }

  function writeRecommendationCache(cart, items) {
    const key = recommendationCacheKey(cart);
    if (!key) return;
    try {
      window.sessionStorage.setItem(key, JSON.stringify({ ts: Date.now(), items: items || [] }));
    } catch (_) {}
  }

  function knownRecommendationItems(_cart) {
    // Recommendations are controlled exclusively by the live Cart Rules API.
    return [];
  }

    function mergeRecommendationItems(primary, secondary) {
    const seen = new Set();
    return [...(primary || []), ...(secondary || [])].filter((entry) => {
      const key = String(entry?.ruleId || '') + '::' + String(entry?.product?.productId || entry?.product?.variantNumericId || '');
      if (!key || seen.has(key)) return false;
      seen.add(key);
      return entry?.product?.available !== false;
    });
  }

  // Explicit low-priority Cart Rules for 140 no-special-recommendation products.
  // Use prepared Shopify product data for a synchronous first cart render.
  const immediateWipesProducts = [{"productId":"16203013587322","variantNumericId":"57265074766202","title":"6x10cm Mandarin Wise Wipes (1 x 500)","handle":"6x10cm-mandarin-triplex-wise-wipes-1-x-500","imageUrl":"https://cdn.shopify.com/s/files/1/0803/2459/1905/files/packaging_wise_wet_wipe_mandarin_WWET004-15_1.jpg?v=1789382515","price":28,"available":true},{"productId":"16203013751162","variantNumericId":"57265075356026","title":"6x10cm Green Tea Wise Wipes (1 x 500)","handle":"6x10cm-green-tea-triplex-wise-wipes-1-x-500","imageUrl":"https://cdn.shopify.com/s/files/1/0803/2459/1905/files/packaging_wise_wet_wipe_green_tea_WWET003-15_1_4149766e-ba85-4d31-9110-3ec13cb9b542.jpg?v=1789382496","price":28,"available":true},{"productId":"16203015029114","variantNumericId":"57265080533370","title":"6x10cm Lemon Wise Wipes (1 x 500)","handle":"6x10cm-lemon-triplex-wise-wipes-1-x-500","imageUrl":"https://cdn.shopify.com/s/files/1/0803/2459/1905/files/packaging_wise_wet_wipe_lemon_WWET002-15_1.jpg?v=1789382442","price":28,"available":true},{"productId":"16203015127418","variantNumericId":"57265080992122","title":"6x10cm Lavender Wise Wipes (1 x 500)","handle":"6x10cm-lavender-triplex-wise-wipes-1-x-500","imageUrl":"https://cdn.shopify.com/s/files/1/0803/2459/1905/files/packaging_wise_wet_wipe_lavender_WWET001-15_1.jpg?v=1789382465","price":28,"available":true}];
  const immediateWipesRules = {"15124455195002":[[0,"760"],[1,"761"],[2,"620"],[3,"762"]],"15124455719290":[[3,"765"],[0,"763"],[1,"621"],[2,"764"]],"15124494844282":[[2,"622"],[3,"768"],[0,"766"],[1,"767"]],"15124495466874":[[1,"623"],[2,"770"],[3,"771"],[0,"769"]],"15124496187770":[[0,"772"],[1,"773"],[2,"624"],[3,"774"]],"15124500119930":[[3,"777"],[0,"775"],[1,"625"],[2,"776"]],"15124518175098":[[2,"626"],[3,"780"],[0,"778"],[1,"779"]],"15124524106106":[[1,"627"],[2,"782"],[3,"783"],[0,"781"]],"15124525089146":[[0,"784"],[1,"785"],[2,"628"],[3,"786"]],"15124525678970":[[3,"789"],[0,"787"],[1,"629"],[2,"788"]],"15124525973882":[[2,"630"],[3,"792"],[0,"790"],[1,"791"]],"15124530332026":[[1,"631"],[2,"794"],[3,"795"],[0,"793"]],"15124567687546":[[0,"796"],[1,"797"],[2,"632"],[3,"798"]],"15124568605050":[[3,"801"],[0,"799"],[1,"633"],[2,"800"]],"15124569391482":[[2,"634"],[3,"804"],[0,"802"],[1,"803"]],"15124569784698":[[1,"635"],[2,"806"],[3,"807"],[0,"805"]],"15124595736954":[[0,"808"],[1,"809"],[2,"636"],[3,"810"]],"15124600521082":[[3,"813"],[0,"811"],[1,"637"],[2,"812"]],"15124601635194":[[2,"638"],[3,"816"],[0,"814"],[1,"815"]],"15124605993338":[[1,"639"],[2,"818"],[3,"819"],[0,"817"]],"15124607566202":[[0,"820"],[1,"821"],[2,"640"],[3,"822"]],"15124608287098":[[3,"825"],[0,"823"],[1,"641"],[2,"824"]],"15124608516474":[[2,"642"],[3,"828"],[0,"826"],[1,"827"]],"15124662681978":[[1,"643"],[2,"830"],[3,"831"],[0,"829"]],"15124665139578":[[0,"832"],[1,"833"],[2,"644"],[3,"834"]],"15124665500026":[[3,"837"],[0,"835"],[1,"645"],[2,"836"]],"15124665991546":[[2,"646"],[3,"840"],[0,"838"],[1,"839"]],"15124666712442":[[1,"647"],[2,"842"],[3,"843"],[0,"841"]],"15124682473850":[[0,"844"],[1,"845"],[2,"648"],[3,"846"]],"15124686963066":[[3,"849"],[0,"847"],[1,"649"],[2,"848"]],"15124696727930":[[2,"650"],[3,"852"],[0,"850"],[1,"851"]],"15124697678202":[[1,"651"],[2,"854"],[3,"855"],[0,"853"]],"15124703183226":[[0,"856"],[1,"857"],[2,"652"],[3,"858"]],"15124703773050":[[3,"861"],[0,"859"],[1,"653"],[2,"860"]],"15124787888506":[[2,"654"],[3,"864"],[0,"862"],[1,"863"]],"15124836680058":[[1,"655"],[2,"866"],[3,"867"],[0,"865"]],"15124838154618":[[0,"868"],[1,"869"],[2,"656"],[3,"870"]],"15124841890170":[[3,"873"],[0,"871"],[1,"657"],[2,"872"]],"15124843200890":[[2,"658"],[3,"876"],[0,"874"],[1,"875"]],"15126400631162":[[1,"659"],[2,"878"],[3,"879"],[0,"877"]],"15126400663930":[[0,"880"],[1,"881"],[2,"660"],[3,"882"]],"15126400696698":[[3,"885"],[0,"883"],[1,"661"],[2,"884"]],"15126606545274":[[2,"662"],[3,"888"],[0,"886"],[1,"887"]],"15126609953146":[[1,"663"],[2,"890"],[3,"891"],[0,"889"]],"15127580967290":[[0,"892"],[1,"893"],[2,"664"],[3,"894"]],"15127652630906":[[3,"897"],[0,"895"],[1,"665"],[2,"896"]],"15180102467962":[[2,"666"],[3,"900"],[0,"898"],[1,"899"]],"15180119474554":[[1,"667"],[2,"902"],[3,"903"],[0,"901"]],"15446321693050":[[0,"904"],[1,"905"],[2,"668"],[3,"906"]],"15446332244346":[[3,"909"],[0,"907"],[1,"669"],[2,"908"]],"15446342959482":[[2,"670"],[3,"912"],[0,"910"],[1,"911"]],"15645021700474":[[1,"671"],[2,"914"],[3,"915"],[0,"913"]],"15646263345530":[[0,"916"],[1,"917"],[2,"672"],[3,"918"]],"15646381867386":[[3,"921"],[0,"919"],[1,"673"],[2,"920"]],"15646787109242":[[2,"674"],[3,"924"],[0,"922"],[1,"923"]],"15648964182394":[[1,"675"],[2,"926"],[3,"927"],[0,"925"]],"15649004618106":[[0,"928"],[1,"929"],[2,"676"],[3,"930"]],"15649048297850":[[3,"933"],[0,"931"],[1,"677"],[2,"932"]],"15662708392314":[[2,"678"],[3,"936"],[0,"934"],[1,"935"]],"15663138865530":[[1,"679"],[2,"938"],[3,"939"],[0,"937"]],"15663229534586":[[0,"940"],[1,"941"],[2,"680"],[3,"942"]],"15666908004730":[[3,"945"],[0,"943"],[1,"681"],[2,"944"]],"15666995462522":[[2,"682"],[3,"948"],[0,"946"],[1,"947"]],"15671075701114":[[1,"683"],[2,"950"],[3,"951"],[0,"949"]],"15671104045434":[[0,"952"],[1,"953"],[2,"684"],[3,"954"]],"15686773309818":[[3,"957"],[0,"955"],[1,"685"],[2,"956"]],"15686803489146":[[2,"686"],[3,"960"],[0,"958"],[1,"959"]],"15688661205370":[[1,"687"],[2,"962"],[3,"963"],[0,"961"]],"15714260550010":[[0,"964"],[1,"965"],[2,"688"],[3,"966"]],"15762176868730":[[3,"969"],[0,"967"],[1,"689"],[2,"968"]],"15818439164282":[[2,"690"],[3,"972"],[0,"970"],[1,"971"]],"15861088485754":[[1,"691"],[2,"974"],[3,"975"],[0,"973"]],"15861146616186":[[0,"976"],[1,"977"],[2,"692"],[3,"978"]],"15861200519546":[[3,"981"],[0,"979"],[1,"693"],[2,"980"]],"16113187881338":[[2,"694"],[3,"984"],[0,"982"],[1,"983"]],"16124372091258":[[1,"695"],[2,"986"],[3,"987"],[0,"985"]],"16124372189562":[[0,"988"],[1,"989"],[2,"696"],[3,"990"]],"16124372353402":[[3,"993"],[0,"991"],[1,"697"],[2,"992"]],"16124372418938":[[2,"698"],[3,"996"],[0,"994"],[1,"995"]],"16124372451706":[[1,"699"],[2,"998"],[3,"999"],[0,"997"]],"16124372582778":[[0,"1000"],[1,"1001"],[2,"700"],[3,"1002"]],"16124372648314":[[3,"1005"],[0,"1003"],[1,"701"],[2,"1004"]],"16124372681082":[[2,"702"],[3,"1008"],[0,"1006"],[1,"1007"]],"16124372779386":[[1,"703"],[2,"1010"],[3,"1011"],[0,"1009"]],"16124372844922":[[0,"1012"],[1,"1013"],[2,"704"],[3,"1014"]],"16124372910458":[[3,"1017"],[0,"1015"],[1,"705"],[2,"1016"]],"16124373008762":[[2,"706"],[3,"1020"],[0,"1018"],[1,"1019"]],"16124373139834":[[1,"707"],[2,"1022"],[3,"1023"],[0,"1021"]],"16124373238138":[[0,"1024"],[1,"1025"],[2,"708"],[3,"1026"]],"16124373303674":[[3,"1029"],[0,"1027"],[1,"709"],[2,"1028"]],"16129638433146":[[2,"710"],[3,"1032"],[0,"1030"],[1,"1031"]],"16129639907706":[[1,"711"],[2,"1034"],[3,"1035"],[0,"1033"]],"16133051777402":[[0,"1036"],[1,"1037"],[2,"712"],[3,"1038"]],"16133051842938":[[3,"1041"],[0,"1039"],[1,"713"],[2,"1040"]],"16133051908474":[[2,"714"],[3,"1044"],[0,"1042"],[1,"1043"]],"16138510729594":[[1,"715"],[2,"1046"],[3,"1047"],[0,"1045"]],"16160380944762":[[0,"1048"],[1,"1049"],[2,"716"],[3,"1050"]],"16165404737914":[[3,"1053"],[0,"1051"],[1,"717"],[2,"1052"]],"16165404770682":[[2,"718"],[3,"1056"],[0,"1054"],[1,"1055"]],"16165404803450":[[1,"719"],[2,"1058"],[3,"1059"],[0,"1057"]],"16165404836218":[[0,"1060"],[1,"1061"],[2,"720"],[3,"1062"]],"16165404868986":[[3,"1065"],[0,"1063"],[1,"721"],[2,"1064"]],"16165405098362":[[2,"722"],[3,"1068"],[0,"1066"],[1,"1067"]],"16165405131130":[[1,"723"],[2,"1070"],[3,"1071"],[0,"1069"]],"16165405163898":[[0,"1072"],[1,"1073"],[2,"724"],[3,"1074"]],"16167877542266":[[3,"1077"],[0,"1075"],[1,"725"],[2,"1076"]],"16172799099258":[[2,"726"],[3,"1080"],[0,"1078"],[1,"1079"]],"16178353963386":[[1,"727"],[2,"1082"],[3,"1083"],[0,"1081"]],"16178353996154":[[0,"1084"],[1,"1085"],[2,"728"],[3,"1086"]],"16190629937530":[[3,"1089"],[0,"1087"],[1,"729"],[2,"1088"]],"16190630101370":[[2,"730"],[3,"1092"],[0,"1090"],[1,"1091"]],"16190764155258":[[1,"731"],[2,"1094"],[3,"1095"],[0,"1093"]],"16190768578938":[[0,"1096"],[1,"1097"],[2,"732"],[3,"1098"]],"16190769037690":[[3,"1101"],[0,"1099"],[1,"733"],[2,"1100"]],"16203013587322":[[2,"734"],[3,"1104"],[0,"1102"],[1,"1103"]],"16203015127418":[[1,"735"],[2,"1106"],[3,"1107"],[0,"1105"]],"16236184633722":[[0,"1108"],[1,"1109"],[2,"736"],[3,"1110"]],"16236186173818":[[3,"1113"],[0,"1111"],[1,"737"],[2,"1112"]],"16236186272122":[[2,"738"],[3,"1116"],[0,"1114"],[1,"1115"]],"16236186370426":[[1,"739"],[2,"1118"],[3,"1119"],[0,"1117"]],"16236186435962":[[0,"1120"],[1,"1121"],[2,"740"],[3,"1122"]],"16236186501498":[[3,"1125"],[0,"1123"],[1,"741"],[2,"1124"]],"16236186632570":[[2,"742"],[3,"1128"],[0,"1126"],[1,"1127"]],"16236186698106":[[1,"743"],[2,"1130"],[3,"1131"],[0,"1129"]],"16236186763642":[[0,"1132"],[1,"1133"],[2,"744"],[3,"1134"]],"16236187353466":[[3,"1137"],[0,"1135"],[1,"745"],[2,"1136"]],"16236187451770":[[2,"746"],[3,"1140"],[0,"1138"],[1,"1139"]],"16236187517306":[[1,"747"],[2,"1142"],[3,"1143"],[0,"1141"]],"16236187582842":[[0,"1144"],[1,"1145"],[2,"748"],[3,"1146"]],"16236187681146":[[3,"1149"],[0,"1147"],[1,"749"],[2,"1148"]],"16236187746682":[[2,"750"],[3,"1152"],[0,"1150"],[1,"1151"]],"16236187779450":[[1,"751"],[2,"1154"],[3,"1155"],[0,"1153"]],"16236187910522":[[0,"1156"],[1,"1157"],[2,"752"],[3,"1158"]],"16236188270970":[[3,"1161"],[0,"1159"],[1,"753"],[2,"1160"]],"16236188369274":[[2,"754"],[3,"1164"],[0,"1162"],[1,"1163"]],"16236188434810":[[1,"755"],[2,"1166"],[3,"1167"],[0,"1165"]],"16236188533114":[[0,"1168"],[1,"1169"],[2,"756"],[3,"1170"]],"16236188598650":[[3,"1173"],[0,"1171"],[1,"757"],[2,"1172"]],"16236188696954":[[2,"758"],[3,"1176"],[0,"1174"],[1,"1175"]],"16236188762490":[[1,"759"],[2,"1178"],[3,"1179"],[0,"1177"]]};

  function instantIndexMatches(cart) {
    if (!cart?.items?.length) return [];
    const index = window.__PW_CART_RULES_INSTANT__ || {};
    const cartIds = cartProductIds(cart);
    const inCart = new Set(cartIds);
    const blocked = new Set(index.outOfStock || []);
    for (const productId of cartIds) {
      for (const incompatibleId of index.excluded?.[productId] || []) blocked.add(incompatibleId);
    }
    const matched = [], seen = new Set();
    // Other explicit complementary products take precedence.
    for (const productId of cartIds) {
      if (immediateWipesRules[productId]) continue;
      for (const rule of index.rules?.[productId] || []) {
        const targetId = String(rule.product?.productId || '').match(/[0-9]+$/)?.[0] || '';
        if (!targetId || inCart.has(targetId) || blocked.has(targetId) || seen.has(targetId) || rule.product?.available === false) continue;
        seen.add(targetId);
        matched.push(rule);
        if (matched.length >= 6) return matched;
      }
    }
    // Four store-managed Wise Wipes recommendations with rotating order.
    // Availability is reconciled by the existing live API in the background.
    for (const productId of cartIds) {
      const rules = immediateWipesRules[productId];
      if (!rules) continue;
      const item = cart.items.find((entry) => String(entry?.product_id || '') === productId);
      const sourceTitle = String(item?.product_title || item?.title || 'Complementary packaging');
      for (const [productIndex, ruleId] of rules) {
        const product = immediateWipesProducts[productIndex];
        if (!product || inCart.has(product.productId) || blocked.has(product.productId) || seen.has(product.productId)) continue;
        seen.add(product.productId);
        matched.push({ruleId, sourceProductId:productId, sourceTitle, product});
        if (matched.length >= 6) return matched;
      }
    }
    return matched;
  }

  let displayedRecommendationCartKey = '';
  let confirmedEmptyRecommendationCartKey = '';
  function renderImmediateRecommendations(cart) {
    if (!cart?.items?.length) {
      displayedRecommendationCartKey = '';
      renderRecommendations([]);
      return;
    }
    const key = recommendationCacheKey(cart);
    if (confirmedEmptyRecommendationCartKey === key) {
      // A successful live lookup confirmed that this cart has no offers.
      // Do not flash outdated index suggestions on each drawer reopen.
      if (displayedRecommendationCartKey !== key) renderRecommendations([]);
      displayedRecommendationCartKey = key;
      return;
    }
    const drawer = drawerProductsHost();
    const page = pageCartProductsHost();
    const drawerReady = !drawer || !!drawer.querySelector('[data-pw-cart-rules][data-pw-dynamic] [data-pw-rule-card]');
    const pageReady = !page || !!page.querySelector('[data-pw-cart-rules][data-pw-dynamic] [data-pw-rule-card]');
    // Preserve already-hydrated cards; synchronous cart events must not replace
    // them with index placeholders or momentarily remove the buttons.
    if (displayedRecommendationCartKey === key && drawerReady && pageReady) return;

    const instant = instantIndexMatches(cart);
    // The live API already verified these products for this session. Prefer
    // its complete image/price cards instead of ignoring them when an older
    // static instant index exists (e.g. freshly added Festive Cups).
    const cached = readRecommendationCache(cart);
    const prepared = cached.length ? cached : instant;
    if (prepared.length) {
      renderRecommendations(prepared);
      displayedRecommendationCartKey = key;
    } else if (displayedRecommendationCartKey !== key) {
      // Clear only after the actual cart product set changes, never on
      // duplicate open/render notifications for the same cart.
      renderRecommendations([]);
      displayedRecommendationCartKey = key;
    }
  }

  function optimisticCartWithAdded(added) {
    const addedItems = Array.isArray(added?.items) ? added.items : (added?.product_id ? [added] : []);
    if (!addedItems.length) return lastCart;
    const baseItems = Array.isArray(lastCart?.items) ? [...lastCart.items] : [];
    for (const item of addedItems) {
      const productId = String(item?.product_id || '');
      if (!productId) continue;
      const existing = baseItems.find((entry) => String(entry?.product_id || '') === productId);
      if (existing) {
        existing.quantity = Number(existing.quantity || 0) + Number(item.quantity || 1);
      } else {
        baseItems.push(item);
      }
    }
    return {
      ...(lastCart || {}),
      items: baseItems,
      item_count: baseItems.reduce((sum,item)=>sum + Number(item?.quantity || 1),0)
    };
  }

  function currentPageProductId() {
    const candidates = [
      document.body?.dataset?.pwPageProductId,
      window.meta?.product?.id,
      window.ShopifyAnalytics?.meta?.product?.id,
      document.querySelector('[data-product-id][data-product-handle]')?.dataset?.productId
    ];
    return String(candidates.find(Boolean) || '').match(/(\d+)$/)?.[1] || '';
  }

  function speculativeCartWithProduct(cart, productId) {
    if (!cart?.items || !productId) return null;
    if (cartProductIds(cart).includes(String(productId))) return cart;
    const items = [...cart.items, { product_id:Number(productId), quantity:1 }];
    return {
      ...cart,
      items,
      item_count: Number(cart.item_count || 0) + 1
    };
  }

  async function prefetchCurrentProductRecommendations(cart) {
    const productId = currentPageProductId();
    if (!productId || !cart?.items) return;
    const speculative = speculativeCartWithProduct(cart, productId);
    if (!speculative) return;

    const cached = readRecommendationCache(speculative);
    if (cached.length) return;

    try {
      const result = await resolveRules(speculative,[]);
      const hydrated = await hydrateRecommendations(result.recommendations);
      const finalItems = mergeRecommendationItems(hydrated, knownRecommendationItems(speculative));
      if (finalItems.length) {
        writeRecommendationCache(speculative, finalItems);
        // The customer may open the cart while prefetch is still running.
        if (lastCart?.items && recommendationCacheKey(lastCart) === recommendationCacheKey(speculative)) {
          renderRecommendations(finalItems);
        }
      }
    } catch (_) {}
  }

  async function addAndPrimeRecommendations(input, init) {
    window.PWFreeWipes?.resumeAfterCompatibility?.();
    const response = await nativeFetch(input, init);
    if (response.ok) {
      try {
        response.clone().json().then((added) => {
          const optimistic = optimisticCartWithAdded(added);
          if (!optimistic?.items?.length) return;
          lastCart = optimistic;
          renderImmediateRecommendations(optimistic);
        }).catch(() => {});
      } catch (_) {}
    }
    return response;
  }

  async function getCart() {
    if (cartReadInFlight && cartReadEpoch === cartEpoch) return cartReadInFlight;
    const epoch = cartEpoch;
    const request = (async () => {
      const response = await nativeFetch(rootUrl() + 'cart.js', {
        credentials:'same-origin', cache:'no-store', headers:{Accept:'application/json'}
      });
      if (!response.ok) throw new Error('cart_unavailable');
      const fresh = await response.json();
      // An older network response must not replace a newer cart snapshot.
      if (epoch === cartEpoch) lastCart = fresh;
      return fresh;
    })();
    cartReadInFlight = request;
    cartReadEpoch = epoch;
    try { return await request; }
    finally { if (cartReadInFlight === request) cartReadInFlight = null; }
  }

    function compatibilityCacheReady(cart) {
    if (!cart?.items?.length) return false;
    const key = cartProductIds(cart).slice().sort().join('|');
    return compatibilityCacheKey === key;
  }

  function cachedConflicts(cart, candidateVariantIds) {
    if (!compatibilityCacheReady(cart) || !candidateVariantIds?.length) return [];
    const ids = new Set(candidateVariantIds.map(String));
    return enrichConflictImages(compatibilityCache.filter((rule) => ids.has(String(rule?.candidateVariantId || ''))));
  }

  async function resolveRules(cart, candidateVariantIds = []) {
    const ids = cartProductIds(cart).slice().sort().join('|');
    const variants = (candidateVariantIds || []).map(String).sort().join('|');
    const key = shop + ':' + ids + ':' + variants;
    // Reopening the same cart must not continuously retry the recommendation service.
    // Candidate compatibility checks always remain fresh.
    const cached = !variants && recommendationResults.get(key);
    if (cached && cached.until > Date.now()) return cached.result;
    if (ruleRequestsInFlight.has(key)) return ruleRequestsInFlight.get(key);
    const promise = fetchCartRules(cart,candidateVariantIds);
    ruleRequestsInFlight.set(key,promise);
    try {
      const result = await promise;
      if (!variants) {
        if (recommendationResults.size > 20) recommendationResults.clear();
        recommendationResults.set(key, { result, until: Date.now() + (result.verified ? 30000 : 15000) });
      }
      return result;
    }
    finally { if (ruleRequestsInFlight.get(key) === promise) ruleRequestsInFlight.delete(key); }
  }

  async function fetchCartRules(cart, candidateVariantIds = []) {
    let resolved = { recommendations:[], conflicts:[] };
    let verified = false;
    if (endpoint && shop) {
      try {
        const controller = new AbortController();
        // Compatibility must stay fast before add-to-cart; recommendations have more time
        // because Vercel can have cold-start latency.
        const timeout = window.setTimeout(() => controller.abort(), candidateVariantIds.length ? 1400 : 7000);
        const response = await nativeFetch(endpoint,{
          method:'POST',
          mode:'cors',
          signal:controller.signal,
          // Read-only JSON payload sent as a simple cross-origin POST:
          // avoids the separate CORS preflight network round-trip.
          headers:{'Content-Type':'text/plain;charset=UTF-8','Accept':'application/json'},
          body:JSON.stringify({
            shop,
            cartProductIds:cartProductIds(cart),
            candidateVariantIds:candidateVariantIds.map(String)
          })
        }).finally(() => window.clearTimeout(timeout));
        if (!response.ok && !candidateVariantIds.length) {
          console.warn('[PW Cart Rules] Recommendation request returned HTTP', response.status);
        }
        if (response.ok) {
          const payload = await response.json();
          verified = true;
          resolved = {
            recommendations:Array.isArray(payload?.recommendations)?payload.recommendations:[],
            conflicts:Array.isArray(payload?.conflicts)?payload.conflicts:[]
          };
          if (Array.isArray(payload?.compatibilityRules) && candidateVariantIds.length === 0) {
            compatibilityCache = payload.compatibilityRules;
            compatibilityCacheKey = cartProductIds(cart).slice().sort().join('|');
            primeCompatibilityImages(compatibilityCache).then(() => {
              compatibilityCache = enrichConflictImages(compatibilityCache);
            }).catch(() => {});
          }
        }
      } catch (error) {
        if (!candidateVariantIds.length) console.warn('[PW Cart Rules] Recommendation request failed', error?.name || error);
      }
    }
    return { ...mergeTestFallbacks(cart, candidateVariantIds, resolved), verified };
  }

  const productCache = new Map();
  const productSnapshotCache = new Map();
  const variantSnapshotCache = new Map();

  async function variantSnapshot(variantId) {
    const id = String(variantId || '').match(/(\d+)$/)?.[1] || '';
    if (!id) return null;
    if (variantSnapshotCache.has(id)) return variantSnapshotCache.get(id);

    const request = nativeFetch(rootUrl() + 'variants/' + encodeURIComponent(id) + '.js', {
      credentials:'same-origin',
      headers:{Accept:'application/json'}
    }).then(async (response) => {
      if (!response.ok) return null;
      const variant = await response.json();
      const imageUrl = String(
        variant?.featured_image?.src ||
        variant?.featured_image?.url ||
        (typeof variant?.image === 'string' ? variant.image : variant?.image?.src || variant?.image?.url) ||
        ''
      );
      const snapshot = { id, imageUrl, variant };
      variantSnapshotCache.set(id, snapshot);
      return snapshot;
    }).catch(() => null);

    variantSnapshotCache.set(id, request);
    const resolved = await request;
    if (resolved) variantSnapshotCache.set(id, resolved);
    return resolved;
  }

  function cartItemImage(productId) {
    const id = String(productId || '').match(/(\d+)$/)?.[1] || '';
    if (!id || !lastCart?.items) return '';
    const item = lastCart.items.find((entry) => String(entry?.product_id || '') === id);
    return String(item?.featured_image?.url || item?.featured_image?.src || item?.image || '');
  }

  async function productSnapshot(handle) {
    const key = String(handle || '').trim();
    if (!key) return null;
    if (productSnapshotCache.has(key)) return productSnapshotCache.get(key);

    let request = productCache.get(key);
    if (!request) {
      request = nativeFetch(rootUrl() + 'products/' + encodeURIComponent(key) + '.js', {
        credentials:'same-origin',
        headers:{Accept:'application/json'}
      }).then((response) => response.ok ? response.json() : null).catch(() => null);
      productCache.set(key, request);
    }

    const product = await request;
    if (!product) { productCache.delete(key); return null; }
    const snapshot = {
      handle:key,
      title:String(product.title || ''),
      imageUrl:String(
        (typeof product.featured_image === 'string' ? product.featured_image : product.featured_image?.src || product.featured_image?.url) ||
        (typeof product.images?.[0] === 'string' ? product.images[0] : product.images?.[0]?.src || product.images?.[0]?.url) || ''
      ),
      product
    };
    productSnapshotCache.set(key, snapshot);
    return snapshot;
  }

  async function primeCompatibilityImages(rules) {
    const list = Array.isArray(rules) ? rules : [];
    await Promise.all(list.flatMap((rule) => [
      productSnapshot(rule?.cartProductHandle),
      productSnapshot(rule?.candidateProductHandle),
      variantSnapshot(rule?.candidateVariantId)
    ]));
  }

  function enrichConflictImages(conflicts) {
    return (conflicts || []).map((item) => {
      const cartSnapshot = productSnapshotCache.get(String(item?.cartProductHandle || ''));
      const candidateSnapshot = productSnapshotCache.get(String(item?.candidateProductHandle || ''));
      const variantId = String(item?.candidateVariantId || '').match(/(\d+)$/)?.[1] || '';
      const variantSnapshotValue = variantSnapshotCache.get(variantId);
      const resolvedVariant = variantSnapshotValue && typeof variantSnapshotValue.then !== 'function' ? variantSnapshotValue : null;
      return {
        ...item,
        cartProductImageUrl: item?.cartProductImageUrl || cartItemImage(item?.cartProductId) || cartSnapshot?.imageUrl || '',
        candidateProductImageUrl: item?.candidateProductImageUrl || resolvedVariant?.imageUrl || candidateSnapshot?.imageUrl || ''
      };
    });
  }

  async function hydrateRecommendation(entry) {
    const base = entry?.product || {};
    const handle = String(base.handle || '').trim();
    if (!handle) return null;

    // New Cart Rules API includes Shopify-verified stock, price and image.
    // Rendering it directly avoids one extra product AJAX round-trip per card.
    if (base.verified === true && base.available === true
      && String(base.variantNumericId || '').trim()
      && Number.isFinite(Number(base.price))) return entry;

    const snapshot = await productSnapshot(handle);
    const product = snapshot?.product;
    if (!product) return null;
    const variants = Array.isArray(product.variants) ? product.variants : [];
    const preferred = String(base.variantNumericId || '');
    // Never silently swap an out-of-stock, explicitly matched variant
    // for another option (which could be the wrong lid size).
    const variant = preferred
      ? variants.find((item) => String(item.id) === preferred)
      : variants.find((item) => item.available !== false);
    if (!variant || variant.available !== true) return null;

    return {
      ...entry,
      product: {
        ...base,
        title: product.title || base.title || '',
        handle,
        imageUrl: product.featured_image || product.images?.[0] || '',
        price: Number(variant.price || 0) / 100,
        variantNumericId: String(variant.id || preferred),
        available: variant.available !== false
      }
    };
  }

  async function hydrateRecommendations(items) {
    const hydrated = await Promise.all((items || []).map(hydrateRecommendation));
    return hydrated.filter(Boolean);
  }

  const numericProductId = (value) => String(value || '').match(/(\d+)$/)?.[1] || '';

  let linkedSourceProductId = '';

  function removeSourceConnector() {
    document.querySelector('header-cart-drawer [data-pw-cart-rule-connector]')?.remove();
  }

  function clearSourceLinks() {
    document.querySelectorAll('header-cart-drawer .cart__item.pw-cart-rule-source').forEach((item) => item.classList.remove('pw-cart-rule-source'));
    linkedSourceProductId = '';
    removeSourceConnector();
  }

  function drawSourceConnector() {
    removeSourceConnector();
    if (!linkedSourceProductId) return;

    const scroll = document.querySelector('header-cart-drawer .cart__scrollable');
    const source = document.querySelector('header-cart-drawer .cart__item[data-product-id="' + CSS.escape(linkedSourceProductId) + '"]');
    const module = document.querySelector('header-cart-drawer [data-pw-cart-rules][data-source-product-id="' + CSS.escape(linkedSourceProductId) + '"]:not([hidden])');
    if (!scroll || !source || !module || source.classList.contains('pw-winback-cart-hidden')) return;

    const scrollRect = scroll.getBoundingClientRect();
    const sourceRect = source.getBoundingClientRect();
    const moduleRect = module.getBoundingClientRect();

    const x1 = sourceRect.left - scrollRect.left + scroll.scrollLeft + 20;
    const y1 = sourceRect.bottom - scrollRect.top + scroll.scrollTop - 1;
    const x2 = moduleRect.left - scrollRect.left + scroll.scrollLeft + 1;
    const y2 = moduleRect.top - scrollRect.top + scroll.scrollTop + 18;
    const bendY = Math.max(y1 + 8, y2 - 8);
    const radius = Math.min(8, Math.max(4, (x2 - x1) / 3));

    const svg = document.createElementNS('http://www.w3.org/2000/svg','svg');
    svg.setAttribute('data-pw-cart-rule-connector','');
    svg.setAttribute('aria-hidden','true');
    svg.setAttribute('width', String(Math.max(scroll.scrollWidth, scroll.clientWidth)));
    svg.setAttribute('height', String(Math.max(scroll.scrollHeight, scroll.clientHeight)));
    svg.setAttribute('viewBox', '0 0 ' + Math.max(scroll.scrollWidth, scroll.clientWidth) + ' ' + Math.max(scroll.scrollHeight, scroll.clientHeight));
    svg.classList.add('pw-cart-rule-connector');

    const path = document.createElementNS('http://www.w3.org/2000/svg','path');
    const horizontalStart = Math.min(x2, x1 + radius);
    const d = x2 > x1
      ? 'M ' + x1 + ' ' + y1 + ' V ' + bendY + ' Q ' + x1 + ' ' + y2 + ' ' + horizontalStart + ' ' + y2 + ' H ' + x2
      : 'M ' + x1 + ' ' + y1 + ' V ' + y2 + ' H ' + x2;
    path.setAttribute('d', d);
    path.setAttribute('fill','none');
    path.setAttribute('stroke','#6fa653');
    path.setAttribute('stroke-width','2');
    path.setAttribute('stroke-linecap','round');
    path.setAttribute('stroke-linejoin','round');
    svg.append(path);
    scroll.append(svg);
  }

  function linkSourceItem(sourceProductId) {
    const id = numericProductId(sourceProductId);
    const source = id && document.querySelector(
      'header-cart-drawer .cart__item[data-product-id="' + CSS.escape(id) + '"]:not(.pw-winback-cart-hidden)'
    );
    if (!source) {
      clearSourceLinks();
      return;
    }
    if (linkedSourceProductId !== id || !source.classList.contains('pw-cart-rule-source')) {
      document.querySelectorAll('header-cart-drawer .cart__item.pw-cart-rule-source')
        .forEach((item) => item.classList.remove('pw-cart-rule-source'));
      source.classList.add('pw-cart-rule-source');
      linkedSourceProductId = id;
    }
    requestAnimationFrame(() => requestAnimationFrame(drawSourceConnector));
  }

    function pageCartProductsHost() {
    return document.querySelector('#CartPageForm [data-products]');
  }

  function clearPageRecommendations() {
    document.querySelectorAll('#CartPageForm [data-pw-cart-rules-page-inline][data-pw-dynamic]').forEach((node) => node.remove());
  }

  function pageRecommendationMarkup(entries, sourceId) {
    return '<div class="pw-cart-rules pw-cart-rules--page-inline" data-pw-cart-rules data-pw-cart-rules-page-inline data-pw-dynamic data-placement="cart_page" data-source-product-id="'+esc(sourceId)+'"><button type="button" class="pw-cart-rules__dismiss" data-pw-rule-dismiss aria-label="Hide recommendations">×</button><div class="pw-cart-rules__list">' +
      entries.map((entry) => {
        const p = entry.product || {};
        const image = p.imageUrl ? '<img class="pw-cart-rule-card__image" src="'+esc(p.imageUrl)+'" alt="" loading="eager" fetchpriority="high">' : '<span class="pw-cart-rule-card__image is-empty"></span>';
        return '<article class="pw-cart-rule-card" data-pw-rule-card data-pw-rank="'+esc(entry?._pwRank ?? 999)+'" data-rule-id="'+esc(entry?.ruleId || '')+'" data-source-product-id="'+esc(sourceId)+'" data-source-product-title="'+esc(entry?.sourceTitle || '')+'" data-target-product-id="'+esc(p.productId || '')+'" data-target-product-title="'+esc(p.title || '')+'" data-variant-id="'+esc(p.variantNumericId)+'">' +
          image +
          '<div class="pw-cart-rule-card__copy"><span class="pw-cart-rules__badge">RECOMMENDED</span><span class="pw-cart-rule-card__title">'+esc(p.title)+'</span><strong class="pw-cart-rule-card__price">'+recommendationPriceMarkup(p)+'</strong></div>' +
          '<button type="button" class="pw-cart-rule-card__add" data-pw-rule-add'+(p.loading ? ' disabled aria-busy="true"' : '')+'>'+(p.loading ? 'Checking…' : 'ADD TO ORDER')+'</button></article>';
      }).join('') + '</div></div>';
  }

  function renderPageRecommendations(items) {
    const products = pageCartProductsHost();
    if (!products) return;

    const signature = recommendationRenderSignature(items);
    const groups = new Map();
    for (const entry of items || []) {
      const sourceId = numericProductId(entry?.sourceProductId || '');
      if (!sourceId) continue;
      if (!groups.has(sourceId)) groups.set(sourceId, []);
      groups.get(sourceId).push(entry);
    }
    const existing = [...products.querySelectorAll('[data-pw-cart-rules-page-inline][data-pw-dynamic]')];
    products.querySelectorAll('[data-pw-liquid-fallback][data-source-product-id]').forEach((module) => {
      if (groups.has(numericProductId(module.dataset.sourceProductId))) module.remove();
    });
    if (groups.size && existing.length === groups.size && [...groups.keys()].every((id) => {
      const source = products.querySelector('.cart__item[data-product-id="' + CSS.escape(id) + '"]');
      return source && existing.some((node) => node.dataset.sourceProductId === id
        && node.dataset.pwSignature === signature && node.previousElementSibling === source);
    })) return;

    // Add replacement content before removing the previous modules to avoid
    // a visible flash on slow devices.
    const retained = new Set();
    for (const [sourceId, entries] of groups) {
      const source = products.querySelector('.cart__item[data-product-id="' + CSS.escape(sourceId) + '"]');
      if (!source) continue;
      const prior = existing.find((node) => node.dataset.sourceProductId === sourceId);
      if (prior?.dataset.pwSignature === signature) {
        if (prior.previousElementSibling !== source) source.insertAdjacentElement('afterend', prior);
        retained.add(prior);
        continue;
      }
      const liquidFallback = products.querySelector('[data-pw-liquid-fallback][data-source-product-id="' + CSS.escape(sourceId) + '"]');
      liquidFallback?.remove();
      source.insertAdjacentHTML('afterend', pageRecommendationMarkup(entries, sourceId));
      const inserted = source.nextElementSibling;
      if (inserted?.matches?.('[data-pw-cart-rules-page-inline][data-pw-dynamic]')) {
        inserted.dataset.pwSignature = signature;
        retained.add(inserted);
      }
    }
    existing.forEach((node) => { if (!retained.has(node)) node.remove(); });
  }

  function linkExistingFallbackSource() {
    placeDrawerFallback();
  }

  function drawerProductsHost() {
    return document.querySelector('header-cart-drawer .cart__scrollable [data-products]');
  }

  function drawerRecommendationMarkup(entries, sourceId) {
    return '<div class="pw-cart-rules pw-cart-rules--drawer-inline" data-pw-cart-rules data-pw-dynamic data-placement="cart_drawer" data-source-product-id="'+esc(sourceId)+'"><button type="button" class="pw-cart-rules__dismiss" data-pw-rule-dismiss aria-label="Hide recommendations">×</button><div class="pw-cart-rules__list">' +
      entries.map((entry) => {
        const p = entry.product || {};
        const image = p.imageUrl ? '<img class="pw-cart-rule-card__image" src="'+esc(p.imageUrl)+'" alt="" loading="eager" fetchpriority="high">' : '<span class="pw-cart-rule-card__image is-empty"></span>';
        return '<article class="pw-cart-rule-card" data-pw-rule-card data-pw-rank="'+esc(entry?._pwRank ?? 999)+'" data-rule-id="'+esc(entry?.ruleId || '')+'" data-source-product-id="'+esc(sourceId)+'" data-source-product-title="'+esc(entry?.sourceTitle || '')+'" data-target-product-id="'+esc(p.productId || '')+'" data-target-product-title="'+esc(p.title || '')+'" data-variant-id="'+esc(p.variantNumericId)+'">' +
          image +
          '<div class="pw-cart-rule-card__copy"><span class="pw-cart-rules__badge">RECOMMENDED</span><span class="pw-cart-rule-card__title">'+esc(p.title)+'</span><strong class="pw-cart-rule-card__price">'+recommendationPriceMarkup(p)+'</strong></div>' +
          '<button type="button" class="pw-cart-rule-card__add" data-pw-rule-add'+(p.loading ? ' disabled aria-busy="true"' : '')+'>'+(p.loading ? 'Checking…' : 'ADD TO ORDER')+'</button></article>';
      }).join('') + '</div></div>';
  }

  function placeDrawerFallback() {
    const products = drawerProductsHost();
    if (!products) return false;
    const fallback = document.querySelector('header-cart-drawer [data-pw-liquid-fallback][data-source-product-id]');
    if (!fallback) return false;
    const sourceId = fallback.dataset.sourceProductId || '';
    const fallbackCard = fallback.querySelector('[data-pw-rule-card]');
    if (fallbackCard && isRecommendationDismissed(fallbackCard.dataset.sourceProductId, fallbackCard.dataset.variantId, 'cart_drawer')) {
      fallback.remove();
      return false;
    }
    const source = products.querySelector('.cart__item[data-product-id="' + CSS.escape(sourceId) + '"]');
    if (!source) { fallback.remove(); return false; }
    fallback.classList.add('pw-cart-rules--drawer-inline');
    if (fallback.previousElementSibling !== source) source.insertAdjacentElement('afterend', fallback);
    return true;
  }

  function sourceProductIdsFromDOM(host) {
    return new Set([...host.querySelectorAll('.cart__item[data-product-id]')]
      .map((row) => numericProductId(row.dataset.productId))
      .filter(Boolean));
  }
  function pruneOrphanedRecommendations() {
    const surfaces = [
      { host: drawerProductsHost(), root: document.querySelector('header-cart-drawer') },
      { host: pageCartProductsHost(), root: document.querySelector('#CartPageForm') },
    ];
    for (const { host, root } of surfaces) {
      if (!host || !root) continue;
      const present = sourceProductIdsFromDOM(host);
      root.querySelectorAll('[data-pw-cart-rules][data-source-product-id]').forEach((module) => {
        const sourceId = numericProductId(module.dataset.sourceProductId);
        if (sourceId && !present.has(sourceId)) module.remove();
      });
    }
    const drawer = drawerProductsHost();
    if (!drawer || !sourceProductIdsFromDOM(drawer).has(linkedSourceProductId))
      clearSourceLinks();
  }
  function syncSourceConnector() {
    const drawer = drawerProductsHost();
    if (!drawer) return;
    const module = [...drawer.querySelectorAll('[data-pw-cart-rules][data-source-product-id]')]
      .find((item) => !item.hidden &&
        item.querySelector('[data-pw-rule-card]:not([hidden])') &&
        sourceProductIdsFromDOM(drawer).has(numericProductId(item.dataset.sourceProductId)));
    if (!module) { clearSourceLinks(); return; }
    linkSourceItem(module.dataset.sourceProductId);
  }

  function recommendationRenderSignature(entries) {
    return (entries || []).map((entry) => {
      const p = entry?.product || {};
      return [
        numericProductId(entry?.sourceProductId || ''),
        String(entry?.ruleId || ''),
        String(p.variantNumericId || ''),
        String(p.price || ''),
        String(p.available !== false)
      ].join(':');
    }).sort().join('|');
  }

  function renderDrawerRecommendations(items) {
    const products = drawerProductsHost();
    if (!products) return;

    const signature = recommendationRenderSignature(items);
    const groups = new Map();
    for (const entry of items || []) {
      const sourceId = numericProductId(entry?.sourceProductId || '');
      if (!sourceId) continue;
      if (!groups.has(sourceId)) groups.set(sourceId, []);
      groups.get(sourceId).push(entry);
    }
    const existing = [...products.querySelectorAll('[data-pw-cart-rules][data-pw-dynamic]')];
    if (groups.size && existing.length === groups.size && [...groups.keys()].every((id) => {
      const source = products.querySelector('.cart__item[data-product-id="' + CSS.escape(id) + '"]');
      return source && existing.some((node) => node.dataset.sourceProductId === id
        && node.dataset.pwSignature === signature && node.previousElementSibling === source);
    })) return;

    if (!groups.size) {
      existing.forEach((node) => node.remove());
      placeDrawerFallback();
      return;
    }

    const retained = new Set();
    for (const [sourceId, entries] of groups) {
      const source = products.querySelector('.cart__item[data-product-id="' + CSS.escape(sourceId) + '"]');
      if (!source) continue;
      const prior = existing.find((node) => node.dataset.sourceProductId === sourceId);
      if (prior?.dataset.pwSignature === signature) {
        if (prior.previousElementSibling !== source) source.insertAdjacentElement('afterend', prior);
        retained.add(prior);
        continue;
      }
      // Retain the previous card until its replacement is already in the DOM.
      source.insertAdjacentHTML('afterend', drawerRecommendationMarkup(entries, sourceId));
      const inserted = source.nextElementSibling;
      if (inserted?.matches?.('[data-pw-cart-rules][data-pw-dynamic]')) {
        inserted.dataset.pwSignature = signature;
        retained.add(inserted);
      }
    }
    existing.forEach((node) => { if (!retained.has(node)) node.remove(); });
    if (retained.size) {
      document.querySelectorAll('header-cart-drawer [data-pw-liquid-fallback]').forEach((node) => node.remove());
    } else {
      placeDrawerFallback();
    }
  }

  // Two visible recommendations globally per cart surface, with optional expansion.
  const expandedRecommendations = { cart_drawer:false, cart_page:false };
  function applyRecommendationDisclosure(placement) {
    const host = placement === 'cart_drawer'
      ? document.querySelector('header-cart-drawer .cart__scrollable')
      : document.querySelector('#CartPageForm');
    if (!host) return;
    const modules = [...host.querySelectorAll('[data-pw-cart-rules]')];
    modules.forEach(module => {
      module.querySelectorAll('[data-pw-rule-more]').forEach(button => button.remove());
    });
    const rankedCards = modules.flatMap(module=>[...module.querySelectorAll('[data-pw-rule-card]')])
      .sort((a,b)=>(Number(a.dataset.pwRank ?? 999)-Number(b.dataset.pwRank ?? 999)));
    if (!rankedCards.length) return;
    const revealAll = expandedRecommendations[placement] || rankedCards.length <= 2;
    const allowed = new Set(revealAll ? rankedCards : rankedCards.slice(0,2));
    modules.forEach(module => {
      const cards = [...module.querySelectorAll('[data-pw-rule-card]')];
      cards.forEach(card => {card.hidden = !allowed.has(card);});
      module.hidden = !cards.some(card=>!card.hidden);
    });
    if (rankedCards.length <= 2) return;
    const anchorCard = revealAll ? rankedCards[rankedCards.length-1] : rankedCards[1];
    const anchorModule = anchorCard?.closest('[data-pw-cart-rules]');
    const list = anchorModule?.querySelector('.pw-cart-rules__list');
    if (!list) return;
    const toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'pw-cart-rules__more';
    toggle.setAttribute('data-pw-rule-more',placement);
    toggle.setAttribute('aria-expanded',String(revealAll));
    toggle.textContent = revealAll ? 'Show less' : 'View more ('+(rankedCards.length-2)+')';
    list.appendChild(toggle);
  }

  function matchingCupLidPriority(entry) {
    const source = String(entry?.sourceTitle || '').toLowerCase();
    const target = String(entry?.product?.title || '').toLowerCase();
    if (!/\bwhite\b.*\bhot cup\b/.test(source) || !/sip\s*thru\s*lid/.test(target)) return 0;
    const cupMm = source.match(/(\d{2,3})\s*mm/)?.[1] || '';
    const lidMm = target.match(/(\d{2,3})\s*mm/)?.[1] || '';
    if (cupMm && lidMm && cupMm !== lidMm) return -100;
    return /\bwhite\b/.test(target) ? 3 : /\bblack\b/.test(target) ? 2 : 1;
  }
  function renderRecommendations(items) {
    const relevanceSorted = [...(items || [])].sort((a,b)=>{
      if(String(a?.sourceProductId||'') !== String(b?.sourceProductId||'')) return 0;
      return matchingCupLidPriority(b)-matchingCupLidPriority(a);
    });
    const ranked = relevanceSorted.map((entry,index)=>({...entry,_pwRank:index}));
    renderPageRecommendations(filterDismissedRecommendations(ranked,'cart_page'));
    renderDrawerRecommendations(filterDismissedRecommendations(ranked,'cart_drawer'));
    pruneDismissedRecommendationModules();
    applyRecommendationDisclosure('cart_drawer');
    applyRecommendationDisclosure('cart_page');
    trackVisibleRecommendationModules();
    pruneOrphanedRecommendations();
    syncSourceConnector();
  }

  async function refreshRecommendations(cart) {
    if (recommendationRefreshInFlight) {
      recommendationRefreshQueuedCart = cart?.items ? cart : (lastCart || recommendationRefreshQueuedCart);
      return;
    }

    recommendationRefreshInFlight = true;
    try {
      const state = cart?.items ? cart : await getCart().catch(()=>null);
      if (!state || !Number(state.item_count || state.items?.length || 0)) {
        lastCart = state;
        renderRecommendations([]);
        return;
      }

      lastCart = state;
      const stateKey = recommendationCacheKey(state);
      // Draw immediately from the local snapshot. The async Cart Rules API
      // then reconciles paused rules, price/stock changes and incompatibility.
      renderImmediateRecommendations(state);
      const previouslyRendered = readRecommendationCache(state);
      const instant = instantIndexMatches(state);
      const result = await resolveRules(state,[]);
      // Never let an older, slower response overwrite suggestions for a
      // cart updated while the network request was in flight.
      if (recommendationCacheKey(lastCart) !== stateKey) return;
      // Timeout, HTTP error or offline is not an authoritative "no offers".
      // Keep the instant cards usable and retry on the next cart refresh.
      if (!result.verified) return;
      // Show matches immediately after API data, before the image/price
      // hydration requests; never downgrade an existing full card to a spinner.
      const pending = (result.recommendations || []).map((entry)=>({
        ...entry,
        product:{...(entry.product || {}), loading:true, price:null, imageUrl:''}
      }));
      if (pending.length && !previouslyRendered.length && !instant.length
        && !result.recommendations.every((entry) => entry?.product?.verified === true))
        renderRecommendations(pending);

      const hydrated = await hydrateRecommendations(result.recommendations);
      if (recommendationCacheKey(lastCart) !== stateKey) return;
      const finalItems = mergeRecommendationItems(hydrated,knownRecommendationItems(state));
      // Important: clear the old UI when the API now returns no matches,
      // rather than leaving stale suggestions from a previous cart.
      if (finalItems.length) {
        confirmedEmptyRecommendationCartKey = '';
        writeRecommendationCache(state,finalItems);
      } else {
        confirmedEmptyRecommendationCartKey = stateKey;
        const key = recommendationCacheKey(state);
        if (key) try { window.sessionStorage.removeItem(key); } catch (_) {}
      }
      renderRecommendations(finalItems);
      displayedRecommendationCartKey = stateKey;
    } catch (error) {
      console.warn('[PW Cart Rules] Unable to refresh matching products',error);
    } finally {
      recommendationRefreshInFlight = false;
      if (recommendationRefreshQueuedCart) {
        const queued = recommendationRefreshQueuedCart;
        recommendationRefreshQueuedCart = null;
        scheduleRecommendations(queued,25);
      }
    }
  }

  function scheduleRecommendations(cart, delay=0) {
    clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(()=>refreshRecommendations(cart).catch(()=>{}),delay);
  }

  function ensureModal() {
    let modal = document.querySelector('[data-pw-compat-modal]');
    if (modal) return modal;
    document.body.insertAdjacentHTML('beforeend',
      '<div class="pw-compat-modal" data-pw-compat-modal hidden><div class="pw-compat-modal__panel" role="alertdialog" aria-modal="true" aria-labelledby="pw-compat-title" aria-describedby="pw-compat-copy">' +
      '<button type="button" class="pw-compat-modal__close" data-pw-compat-cancel aria-label="Close">×</button>' +
      '<div class="pw-compat-modal__icon" aria-hidden="true">!</div>' +
      '<div class="pw-compat-modal__head"><span class="pw-compat-modal__eyebrow">Compatibility alert</span><h2 class="pw-compat-modal__title" id="pw-compat-title">These items do not match</h2><p class="pw-compat-modal__copy" id="pw-compat-copy">The product you are adding is not compatible with an item already in your cart.</p></div>' +
      '<div class="pw-compat-modal__items" data-pw-compat-items></div>' +
      '<div class="pw-compat-modal__actions"><button type="button" class="pw-compat-modal__cancel" data-pw-compat-cancel>Go back</button><button type="button" class="pw-compat-modal__continue" data-pw-compat-continue>Add anyway</button></div></div></div>'
    );
    return document.querySelector('[data-pw-compat-modal]');
  }

  function askCompatibility(conflicts, placement = interactionPlacement()) {
    if (modalPromise) return modalPromise;
    const modal = ensureModal();
    const list = modal.querySelector('[data-pw-compat-items]');
    const visibleConflicts = enrichConflictImages(conflicts).slice(0,6);
    // The diameter fallback does not carry a product handle/image. The active
    // product page already has the canonical image, so show it immediately.
    const pageHandle = decodeURIComponent(location.pathname.match(/\/products\/([^/?]+)/)?.[1] || '');
    const pageImage = document.querySelector('meta[property="og:image"]')?.content
      || document.querySelector('.page-content--product .product-main-slide img[src]')?.src
      || '';
    visibleConflicts.forEach(item => {
      if (!item.candidateProductHandle && pageHandle) item.candidateProductHandle = pageHandle;
      if (!item.candidateProductImageUrl && pageHandle && pageImage) item.candidateProductImageUrl = pageImage;
    });
    const imageMarkup = (url, title) => url
      ? '<img class="pw-compat-modal__product-image" src="'+esc(url)+'" alt="'+esc(title)+'" loading="eager">'
      : '<div class="pw-compat-modal__product-image pw-compat-modal__product-image--empty" aria-hidden="true"></div>';

    list.innerHTML = visibleConflicts.map((item, index) => {
      const note = item.message || 'These products are not a compatible size.';
      return '<div class="pw-compat-modal__item" data-pw-compat-item="'+index+'">' +
        '<div class="pw-compat-modal__product"><small>You are adding</small><div class="pw-compat-modal__product-row">'+imageMarkup(item.candidateProductImageUrl,item.candidateProductTitle)+'<strong>'+esc(item.candidateProductTitle)+'</strong></div></div>' +
        '<div class="pw-compat-modal__vs">×</div>' +
        '<div class="pw-compat-modal__product"><small>In your cart</small><div class="pw-compat-modal__product-row">'+imageMarkup(item.cartProductImageUrl,item.cartProductTitle)+'<strong>'+esc(item.cartProductTitle)+'</strong></div></div>' +
        '<p>'+esc(note)+'</p></div>';
    }).join('');
    modal.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    trackCartExperience('compatibility_alert_impression',compatibilityEventData(visibleConflicts,placement,'shown'));

    // If a rule was checked before image preloading completed, show the alert immediately,
    // then fill the images without delaying the customer's decision.
    Promise.all(visibleConflicts.map(async (item, index) => {
      const [candidate, cart, variant] = await Promise.all([
        productSnapshot(item?.candidateProductHandle || pageHandle),
        productSnapshot(item?.cartProductHandle),
        variantSnapshot(item?.candidateVariantId)
      ]);
      const row = list.querySelector('[data-pw-compat-item="'+index+'"]');
      if (!row) return;
      const slots = row.querySelectorAll('.pw-compat-modal__product-image');
      const images = [
        variant?.imageUrl || candidate?.imageUrl || pageImage || '',
        cartItemImage(item?.cartProductId) || cart?.imageUrl || ''
      ];
      slots.forEach((slot, slotIndex) => {
        if (!images[slotIndex] || slot.tagName === 'IMG') return;
        const img = document.createElement('img');
        img.className = 'pw-compat-modal__product-image';
        img.src = images[slotIndex];
        img.alt = slotIndex === 0 ? String(item?.candidateProductTitle || '') : String(item?.cartProductTitle || '');
        slot.replaceWith(img);
      });
    })).catch(() => {});

    modalPromise = new Promise((resolve) => {
      const finish = (answer) => {
        if (!answer) trackCartExperience('compatibility_alert_go_back',compatibilityEventData(visibleConflicts,placement,'go_back'));
        modal.hidden = true;
        document.documentElement.style.overflow = '';
        modal.removeEventListener('click',click);
        document.removeEventListener('keydown',key);
        modalPromise = null;
        resolve(answer);
      };
      const click = (event) => {
        if (event.target.closest('[data-pw-compat-continue]')) finish(true);
        else if (event.target.closest('[data-pw-compat-cancel]') || event.target === modal) finish(false);
      };
      const key = (event) => { if (event.key === 'Escape') finish(false); };
      modal.addEventListener('click',click);
      document.addEventListener('keydown',key);
    });
    return modalPromise;
  }

  function extractVariantIds(body) {
    const ids = [];
    if (!body) return ids;
    if (body instanceof FormData) {
      const direct = body.get('id');
      if (direct) ids.push(String(direct));
      for (const [key,value] of body.entries()) if (/items\[\d+\]\[id\]/.test(key) && value) ids.push(String(value));
      return [...new Set(ids.filter((id)=>/^\d+$/.test(id)))];
    }
    if (typeof body === 'string') {
      try {
        const parsed = JSON.parse(body);
        if (Array.isArray(parsed?.items)) parsed.items.forEach((item)=>item?.id && ids.push(String(item.id)));
        else if (parsed?.id) ids.push(String(parsed.id));
        if (parsed?.updates && typeof parsed.updates === 'object') {
          Object.entries(parsed.updates).forEach(([id,qty]) => { if (Number(qty) > 0 && /^\d+$/.test(id)) ids.push(id); });
        }
      } catch (_) {}
    }
    return [...new Set(ids.filter((id)=>/^\d+$/.test(id)))];
  }

  function isCartAdd(input, init) {
    if ((init?.method || 'GET').toUpperCase() !== 'POST') return false;
    const url = typeof input === 'string' ? input : input?.url || '';
    return /\/cart\/(add|update)\.js(?:\?|$)/.test(url);
  }

  window.fetch = async function(input, init) {
    if (!isCartAdd(input,init)) return nativeFetch(input,init);
    const variantIds = extractVariantIds(init?.body);
    if (!variantIds.length) return nativeFetch(input,init);

    const cart = lastCart?.items ? lastCart : await getCart().catch(()=>null);
    if (!cart?.items?.length) return addAndPrimeRecommendations(input,init);

    const instantFallback = mergeTestFallbacks(cart,variantIds,{recommendations:[],conflicts:[]});
    let conflicts = instantFallback.conflicts;

    if (!conflicts.length && compatibilityCacheReady(cart)) {
      conflicts = cachedConflicts(cart,variantIds);
      // A cached list may be incomplete for a new candidate variant.
      // Always verify an unrecognized pair against the server before adding.
    }

    if (!conflicts.length) {
      const result = await resolveRules(cart,variantIds);
      conflicts = (result.conflicts || []).map((item) => ({
        ...item,
        candidateVariantId: item?.candidateVariantId || variantIds[0] || ''
      }));
    }

    if (!conflicts.length) conflicts = await diameterConflicts(cart,variantIds);
    conflicts = needsCompatibilityConsent(conflicts,cart);
    if (!conflicts.length) return addAndPrimeRecommendations(input,init);

    const alertPlacement = interactionPlacement();
    window.PWFreeWipes?.pauseForCompatibility?.();
    const proceed = await askCompatibility(conflicts,alertPlacement);
    if (proceed) {
      const response = await addAndPrimeRecommendations(input,init);
      if (response?.ok) {
        rememberCompatibilityConsent(conflicts,cart);
        trackCartExperience('compatibility_alert_add_anyway',compatibilityEventData(conflicts,alertPlacement,'add_anyway'));
      }
      return response;
    }

    const error = new Error('');
    error.name = 'PWCompatibilityCancelled';
    throw error;
  };

  window.addEventListener('unhandledrejection',(event)=>{
    if (event.reason?.name === 'PWCompatibilityCancelled') event.preventDefault();
  });

  document.addEventListener('click',async(event)=>{
    const more = event.target.closest('[data-pw-rule-more]');
    if (more) {
      event.preventDefault();
      const placement = more.dataset.pwRuleMore === 'cart_page' ? 'cart_page' : 'cart_drawer';
      expandedRecommendations[placement] = !expandedRecommendations[placement];
      applyRecommendationDisclosure(placement);
      trackVisibleRecommendationModules();
      if (placement === 'cart_drawer') requestAnimationFrame(drawSourceConnector);
      trackCartExperience('cart_recommendation_view_more',{
        placement,action:expandedRecommendations[placement]?'expand':'collapse',
        itemCount:document.querySelectorAll(
          placement === 'cart_drawer'
            ? 'header-cart-drawer [data-pw-rule-card]:not([hidden])'
            : '#CartPageForm [data-pw-rule-card]:not([hidden])'
        ).length
      });
      return;
    }
    const dismiss = event.target.closest('[data-pw-rule-dismiss]');
    if (dismiss) {
      event.preventDefault();
      event.stopPropagation();
      const module = dismiss.closest('[data-pw-cart-rules]');
      if (!module) return;
      const placement = recommendationPlacement(module);
      module.querySelectorAll('[data-pw-rule-card]').forEach((card) => {
        const key = recommendationDismissKey(card.dataset.sourceProductId,card.dataset.variantId,placement);
        if (key) dismissedRecommendationKeys.add(key);
        trackCartExperience('cart_recommendation_dismiss',recommendationEventData(card,placement,'dismiss'));
      });
      persistDismissedRecommendations();
      module.classList.add('is-dismissing');
      window.setTimeout(() => module.remove(), 100);
      return;
    }

    const button = event.target.closest('[data-pw-rule-add]');
    if (!button) return;
    const card = button.closest('[data-pw-rule-card]');
    const pageContext = Boolean(button.closest('#CartPageForm'));
    const id = Number(card?.dataset?.variantId || 0);
    if (!id) return;
    button.disabled = true;
    const old = button.textContent;
    button.textContent = 'Adding…';
    try {
      const response = await window.fetch(rootUrl()+'cart/add.js',{
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({items:[id && cartRecommendationWetWipesVariants.has(String(id)) && /^\d+$/.test(String(card?.dataset?.sourceProductId || ''))
          ? {id,quantity:1,properties:{_pw_cart_recommendation:'true',_pw_recommendation_source_id:String(card.dataset.sourceProductId)}}
          : {id,quantity:1}]})
      });
      if (!response.ok) throw new Error('add_failed');
      const added = await response.json();
      const module = card?.closest('[data-pw-cart-rules]');
      const placement = recommendationPlacement(module);
      trackCartExperience('cart_recommendation_add',recommendationEventData(card,placement,'add'));
      button.textContent = 'Added';
      card?.closest('[data-pw-cart-rules]')?.classList.add('is-added');
      document.dispatchEvent(new CustomEvent('ajaxProduct:added',{bubbles:true,detail:{product:added}}));

      getCart().then((cart) => {
        document.dispatchEvent(new CustomEvent('cart:updated',{detail:{cart}}));
        scheduleRecommendations(cart,0);
      }).catch(() => {
        document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));
      });

      if (pageContext) {
        window.setTimeout(() => document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true})), 0);
        return;
      }
    } catch (error) {
      if (error?.name === 'PWCompatibilityCancelled') button.textContent = old;
      else button.textContent = 'Try again';
    } finally {
      window.setTimeout(()=>{button.disabled=false;if(button.textContent!=='Added')button.textContent=old;},900);
    }
  });

  function acceptCartSnapshot(snapshot) {
    if (!snapshot?.items) return;
    cartEpoch += 1;
    lastCart = snapshot;
    pruneOrphanedRecommendations();
    renderImmediateRecommendations(snapshot);
    scheduleRecommendations(snapshot,35);
  }
  function requestFreshCartAfterMutation() {
    cartEpoch += 1;
    const revision = cartEpoch;
    lastCart = null;
    pruneOrphanedRecommendations();
    void getCart().then((fresh) => {
      if (revision !== cartEpoch) return;
      lastCart = fresh;
      renderImmediateRecommendations(fresh);
      scheduleRecommendations(fresh,25);
    }).catch((error) => console.warn('[PW Cart Rules] Cart synchronization failed', error));
  }
  document.addEventListener('pw:cart:rendered', (event) => {
    if (event.detail?.cart?.items) acceptCartSnapshot(event.detail.cart);
    else requestFreshCartAfterMutation();
  });
  document.addEventListener('cart:open', () => {
    const shared = window.__PW_CART_DATA__?.value;
    if (shared?.items) lastCart = shared;
    if (lastCart?.items) {
      pruneOrphanedRecommendations();
      renderImmediateRecommendations(lastCart);
      scheduleRecommendations(lastCart,25);
    } else requestFreshCartAfterMutation();
  });
  ['ajaxProduct:added','cart:updated','cart:refresh'].forEach((name) =>
    document.addEventListener(name, (event) => {
      if (event.detail?.cart?.items) {
        acceptCartSnapshot(event.detail.cart);
      } else if (Array.isArray(event.detail?.product?.items)) {
        const optimistic = optimisticCartWithAdded(event.detail.product);
        if (optimistic?.items) acceptCartSnapshot(optimistic);
        else requestFreshCartAfterMutation();
      } else {
        // Never reuse lastCart for a mutation with unknown removal/quantity.
        requestFreshCartAfterMutation();
      }
    })
  );
  function watchCartProducts() {
    const selectors = [
      'header-cart-drawer [data-products]',
      '#CartPageForm [data-products]',
    ];
    for (const selector of selectors) {
      const products = document.querySelector(selector);
      if (!products || products.PW_CART_RULES_PRODUCTS_OBSERVER) continue;
      products.PW_CART_RULES_PRODUCTS_OBSERVER = true;
      new MutationObserver((records) => {
        const rowsChanged = records.some((record) => {
          const nodes = [...record.addedNodes, ...record.removedNodes];
          return nodes.some((node) => node?.nodeType === 1 &&
            (node.matches?.('.cart__item') || node.querySelector?.('.cart__item')));
        });
        if (!rowsChanged) return;
        // Remove recommendations and their green connector immediately when
        // the source row disappears. Wait for the real cart snapshot before
        // regenerating cards; do not recreate them from stale lastCart.
        pruneOrphanedRecommendations();
        const domSources = sourceProductIdsFromDOM(products);
        const dataSources = new Set(cartProductIds(lastCart));
        const sameSources = domSources.size === dataSources.size &&
          [...domSources].every((id) => dataSources.has(id));
        if (!sameSources) requestFreshCartAfterMutation();
        else if (lastCart?.items) {
          renderImmediateRecommendations(lastCart);
          scheduleRecommendations(lastCart,35);
        }
      }).observe(products,{childList:true,subtree:true});
    }
  }

    const initializeCartRules = () => {
    ensureModal();
    pruneDismissedRecommendationModules();
    trackVisibleRecommendationModules();
    watchCartProducts();
    linkExistingFallbackSource();

    // Warm live recommendations while viewing the product, before the
    // customer clicks Add to cart. Cached results display beneath that
    // line on the cart's first open without waiting for a cold API request.
    // Pre-warm the recommendations for the product a customer is viewing
    // without delaying page paint. The verified result is cached for the first
    // Add to cart / drawer open; category pages keep the instant-index path.
    if (currentPageProductId()) {
      window.setTimeout(() => {
        const cachedCart = window.__PW_CART_DATA__?.value;
        const warm = (cart) => prefetchCurrentProductRecommendations(cart).catch(() => {});
        if (cachedCart?.items) warm(cachedCart);
        else getCart().then(warm).catch(() => {});
      }, 300);
    }
    if (document.querySelector('#CartPageForm')) {
      scheduleRecommendations(null,0);
    }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',initializeCartRules,{once:true});
  else initializeCartRules();
})();

